<template>
  <div>
<!--    原先国内部署-->
<!--    <el-row> 您是第&nbsp;&nbsp;{{ viewCount }}&nbsp;&nbsp;位访问者 </el-row>-->
<!--    <br />-->
<!--    <el-row> 地址：南开大学津南校区汉语言文化学院 501室 </el-row>-->
<!--    <br />-->

<!--    <el-row>-->
<!--      邮编：300381&nbsp;&nbsp;&nbsp;&nbsp;-->
<!--      电话：022-85358921&nbsp;&nbsp;&nbsp;&nbsp; 电子邮件：SYlinguistics@163.com-->
<!--    </el-row>-->
<!--    <br />-->
<!--    <el-row> 津ICP备2021004835号 </el-row>-->
<!--    <el-row> 您是第&nbsp;&nbsp;{{ viewCount }}&nbsp;&nbsp;位访问者 </el-row>-->
<!--    <br />-->
    <el-row> 〒852-8521 日本長崎県長崎市文教町1-14
    </el-row>
    <br />

    <el-row>
      Copyright（C）2025&nbsp;&nbsp;&nbsp;&nbsp;
      The Society for Experimental Linguistics
    </el-row>
  </div>
</template>

<script>
import { viewCountShow } from '@/api/data.js'
export default {
  name: 'FooterComponent',
  data () {
    return {
      viewCount: 0,
      msg: 'Welcome to Your Vue.js App'
    }
  },
  mounted () {
    viewCountShow().then((res) => {
      this.viewCount = res.data.result
    })
  }
}
</script>

<style scoped>
.footer_item {
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/footerComponent.vue